import { rootRoute } from './routes/__root'
import { indexRoute } from './routes/index'
import { loginRoute } from './routes/login'
import { inviteGateRoute } from './routes/invite-gate'
import { homeRoute } from './routes/home'
import { bussboardRoute } from './routes/bussboard'
import { bussboardEditorRoute } from './routes/bussboard.$id'
import { teamRoute } from './routes/team'
import { werkshopRoute } from './routes/werkshop'
import { werkshopMidiRoute } from './routes/werkshop.midi'
import { werkshopProjectsRoute } from './routes/werkshop.projects'
import { werkshopProjectsEditorRoute } from './routes/werkshop.projects.$id'
import { werkshopToolsRoute } from './routes/werkshop.tools'
import { werkshopSamplerToolRoute } from './routes/werkshop.tools.sampler'
import { werkshopPianoRollToolRoute } from './routes/werkshop.tools.piano-roll'
import { werkshopAutomationToolRoute } from './routes/werkshop.tools.automation'
import { werkshopStoreRoute } from './routes/werkshop.store'
import { werkshopSettingsRoute } from './routes/werkshop.settings'
import { settingsRoute } from './routes/settings'
import { roadmapRoute } from './routes/roadmap'

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  inviteGateRoute,
  homeRoute,
  bussboardRoute,
  bussboardEditorRoute,
  teamRoute,
  werkshopRoute,
  werkshopMidiRoute,
  werkshopProjectsRoute,
  werkshopProjectsEditorRoute,
  werkshopToolsRoute,
  werkshopSamplerToolRoute,
  werkshopPianoRollToolRoute,
  werkshopAutomationToolRoute,
  werkshopStoreRoute,
  werkshopSettingsRoute,
  settingsRoute,
  roadmapRoute,
])

export { routeTree }
